import React, {createRef, useRef} from 'react';
import {Row, Col,} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import Widget from '../../components/Widget';
import s from './Afiliaciones.module.scss';
import Resumen from "./components/resumen";
import {Text} from "recharts";

class Afiliaciones extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = createRef();
    }
    state = {
        data : []
    }
    API_URL = "/resume"

    // componentDidMount() {
    //     fetch(this.API_URL)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log(data)
    //             this.setState({
    //                 data: data
    //             })
    //         });
    // }
    handleClick = (event) => {
        fetch( this.API_URL + "?nit="+ this.inputRef.current.value)
            .then((response) => response.json())
            .then((data) => {
                this.setState({
                    data: data
                })
            });
    };

    render() {
        return (
            <div className={s.root}>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">Estas en</li>
                    <li className="breadcrumb-item active">Afiliaciones</li>
                </ol>
                <Widget>
                <Row>
                <Col xs={12} md ={1}>
                    <label htmlFor= "nit">NIT</label>
                </Col>
                    <Col xs={12} md ={2}>
                    <input
                        ref={this.inputRef}
                        type="text"
                        id="nit"
                        name="nit"
                    />
                </Col>
                <Col xs={12} md ={1}>
                        <button onClick={this.handleClick}>Buscar</button>
                </Col>
                </Row>
                </Widget>
                <Widget title={<h6> Detalle afiliaciones </h6>} close collapse settings>
                    <Row>
                        {/*<Col xs={12} md ={4}>*/}
                        {/*    <Widget>*/}
                        {/*        <TimeFilter />*/}
                        {/*    </Widget>*/}
                        {/*</Col>*/}
                        {/*<Col xs={12} md ={4}>*/}
                        {/*    <Widget>*/}
                        {/*        <MonthFilter />*/}
                        {/*    </Widget>*/}
                        {/*</Col>*/}
                        {/*<Col xs={12} md ={4}>*/}
                        {/*    <Widget>*/}
                        {/*        <SectionalFilter />*/}
                        {/*    </Widget>*/}
                        {/*</Col>*/}
                        <Col lg="12" xs="100%">
                            <div className="location-selector">
                                <Resumen data ={this.state.data} />
                            </div>
                        </Col>
                    </Row>
                </Widget>
            </div>
        );
    }
}

export default Afiliaciones;